import { CopyProperties } from 'src/app/shared/decorator/copy-properties.decorator';
import { ParseDataService } from '../services/parseData.service';

@CopyProperties()
export class Fee {
  applyAt: number;
  beginValue: number;
  destProductId: number;
  destSchemeId: number;
  beginOperatorCode: string;
  endOperatorCode: string;
  endValue: number;
  fee: number;
  id: number;
  productId: number;
  typeCode: string;
  feeUnitCode: string;
  note: string;
  isUnitByDay: boolean;
  fromDate: any;
  toDate: any;
  schemeId: any;
  constructor(
    params?: any
  ) {
    this.applyAt = null;
    this.beginValue = null;
    this.destProductId = null;
    this.destSchemeId = null;
    this.endValue = null;
    this.fee = null;
    this.id = null;
    this.productId = null;
    this.isUnitByDay = false;
    this.beginOperatorCode = '';
    this.endOperatorCode = '';
    this.typeCode = '';
    this.note = '';
    this.feeUnitCode = '';
    this.fromDate = null;
    this.toDate = null;
    this.schemeId = null;
  }
}
